// *** Main JS entry point *** //

// Libraries that are passed to JS Modules (it is important to only instantiate these only once and where possible, these should be loaded in via NPM using the packages.json file and 'npm install')
var mustache = require('mustache');
var masonry = require('masonry-layout');
var cookies = require('js-cookie');
var moment = require('moment');
var urlParameters = require('./lib/urlParameters');

// JS modules that are loaded & run once the dom is loaded
$(document).ready(function () {
    require("./lib/jquery.equal-heights");
    require("./modules/grid")($).init();
    require("./modules/accordions")($).init();
    require("./modules/searchBar")($).init();
    require("./modules/copyForMobile")($).init();
    var addToCollection = require("./modules/addToCollection")($);
    addToCollection.init();
    var addToGlossary = require("./modules/addToGlossary")($);
    addToGlossary.init();
    var removeFromGlossary = require("./modules/removeFromGlossary")($);
    removeFromGlossary.init();
    var historyMap = require("./modules/historyMap")($);
    historyMap.init();
    var eventHero = require("./modules/eventHero")($);
    eventHero.init();
    require("./modules/mediaGallery")($).init();
    require("./modules/artefactList")($).init();
    require("./modules/artefactList")($).init();
    require('./modules/slickCarousel')($).init();
    require("./modules/resourceSearch")($, mustache, urlParameters, addToCollection).init();
    require("./modules/siteSearch")($, mustache, urlParameters, addToCollection).init();
    require("./modules/memberLogin")($).init(); 
    require("./modules/memberRegister")($).init(); 
    require("./modules/memberProfile")($).init();
    require("./modules/eventLocation")($).init();
    require("./modules/eventCalendar")($, mustache, moment).init();
    require("./modules/news")($, masonry, urlParameters).init();
    require("./modules/resourceSearchRM")($).init();
    require("./modules/collectionSection")($).init();
    require("./modules/glossary")($, mustache, urlParameters).init();
    require("./modules/glossaryUpgrade")($, mustache, urlParameters, addToGlossary, removeFromGlossary).init();
    require("./modules/glossaryUpgradeHero")($).init();
    
    require("./modules/global")($, cookies).init();
    require("./modules/meTermsAndConditions")($).init();
    require("./modules/meDbSearch")($, mustache, urlParameters).init();
    require("./modules/meDbOutcomesSearch")($, mustache, urlParameters).init();

    require("./modules/panelGrid")($).init();
    
});